export default __webpack_public_path__ + "static/media/YAS0910.34I-41428_-24759_0.ee04407e.jpg";